// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"198d8a89","976":"b8fbd520"}[chunkId] + ".chunk.js";
};